import { io, type Socket } from 'socket.io-client';
import type { ClientToServerEvents, ServerToClientEvents } from '../types/game';

// Use VITE_SOCKET_URL if set, otherwise determine based on environment
// In production/Docker: use current origin (nginx proxy handles /socket.io/)
// In local dev: connect directly to backend Socket.IO server on port 3001
const getSocketUrl = (): string => {
  if (import.meta.env.VITE_SOCKET_URL) {
    return import.meta.env.VITE_SOCKET_URL;
  }
  
  // In development, connect directly to the backend Socket.IO server
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    return 'http://localhost:3001';
  }
  
  // In production, use current origin (nginx proxy handles routing)
  return typeof window !== 'undefined' ? window.location.origin : '';
};

const SOCKET_URL = getSocketUrl();

export const createSocket = (): Socket<ServerToClientEvents, ClientToServerEvents> => {
  const socket = io(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket', 'polling'], // Allow fallback to polling if websocket fails
    withCredentials: true,
  }) as Socket<ServerToClientEvents, ClientToServerEvents>;
  
  if (import.meta.env.DEV) {
    console.log('[socket] Created socket with URL:', SOCKET_URL);
    socket.on('connect', () => console.log('[socket] Connected'));
    socket.on('disconnect', (reason) => console.log('[socket] Disconnected:', reason));
    socket.on('connect_error', (error) => console.error('[socket] Connection error:', error));
  }
  
  return socket;
};
